define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginToggleButton"
], function(declare,ToolbarPluginToggleButton) {

	return declare(ToolbarPluginToggleButton, {
		//[YG] Used with CrewSecurityTable, CrewUserRolesTable, CrewRoleUsersTable

		postMixInProperties: function() {
			this.inherited(arguments);
			this.defAction.classController = "csi/view/RefreshController";
		},

		isToggledInitially: function(/*Context?*/ctx) {
			// summary: determine toggle status of action

			if (this.getView().get("bFreezeToggle")) {
				this._setDisabled(this, true);
			}

			return this.getView().get("displayGlobalAssignments");
		},

		onChange: function(/*Object*/value, /*Action*/action) {
			// summary: user callback for when widget value changes
			this.getView().set("displayGlobalAssignments", value);
			this.inherited(arguments);
		}
	});
});